import { DropdownWithLabelOptionType } from '@/trio-ui/Dropdown/Dropdown.types';
import WorkExperience, { WorkExperienceComponentProps } from './WorkExperience.component';
import ProfileInfoPreview from '../ProfileInfoPreview';

export type WorkExperienceProps = WorkExperienceComponentProps & {
  techs: string[];
  isEditing: boolean;
  isSubmitting: boolean;
  onDeleteExperience: () => void;
  onEditExperience: () => void;
  techOptions: DropdownWithLabelOptionType[];
};

export default function WorkExperienceContainer({
  isEditing,
  isSubmitting,
  techOptions,
  yearOptions,
  ...props
}: WorkExperienceProps): JSX.Element {
  const skillsSelected = techOptions.filter((tech) => props.techs.includes(tech.value));
  const skillLabels = skillsSelected?.map((tech) => tech.label);

  return isEditing ? (
    <WorkExperience isSubmitting={isSubmitting} yearOptions={yearOptions} {...props} />
  ) : (
    <ProfileInfoPreview
      onDelete={props.onDeleteExperience}
      title={props.company ?? ''}
      subtitle={props.title}
      detail={props.location}
      skills={skillLabels}
      description={props.description}
      fromMonth={props.startMonth}
      fromYear={props.startYear}
      toMonth={props.endMonth}
      toYear={props.endYear}
      showToPeriod={props.isCurrentWork}
      datePeriodLabel="Currently work here"
      onEditInfo={props.onEditExperience}
    />
  );
}
